const baseStyle = {
    color: "font.primary",
};
const variantLarge = {
    fontSize: "lg",
    lineHeight: "base",
    fontWeight: "normal",
};
const variantMedium = {
    fontSize: "md",
    lineHeight: "base",
    fontWeight: "normal",
};
const variants = {
    large: variantLarge,
    medium: variantMedium,
};
const defaultProps = {
    variant: "large",
};
const Text = {
    baseStyle,
    variants,
    defaultProps,
};
export default Text;
